import React, { useContext, useState } from 'react';
import HttpStatus from 'http-status-codes';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { getHeaders } from '../../request';
import axios from 'axios';
import {
    SttModal,
    SttLoading,
    SttTranslateHook
} from '@stt-componentes/core';
import { SttButton } from '@stt-componentes/core-v2';
import { configure, open } from '../../reducers/alerta';

const ConfirmarLaudo = (props) => {
    const { html, callbackConfirmar, callbackCancelar, modalAberto, idExame } = props;

    const dispatch = useDispatch();
    const { values, resetForm } = useFormikContext();

    const { strings } = useContext(SttTranslateHook.I18nContext);
    const user = useSelector(state => state.index.user);

    const [confirmando, setConfirmando] = useState(false);
    const [assinando, setAssinando] = useState(false);

    const confirmar = () => {
        setConfirmando(true);
        axios.post(`${global.gConfig.url_base_eeg}/laudo/confirmar`, values, { headers: getHeaders() })
            .then((response) => {
                resetForm();

                if (user.cpf && user.idufsc) {
                    const urlAuthAssinaturaDigital = `${global.gConfig.url_base_assinatura_digital_ufsc}?cpfAssinador=${user.cpf}`;
                    let win = window.open(urlAuthAssinaturaDigital, "_blank", "height=800, width=1000;");
                    let timer = setInterval(() => {
                        if (win.closed) {
                            clearInterval(timer);
                            setAssinando(true);
                            let alertConfig = {
                                open: true,
                                options: [
                                    {
                                        title: strings.ok,
                                        onClick: () => {
                                            dispatch(open(false));
                                            callbackConfirmar();
                                        }
                                    }
                                ],
                                onClose: () => {
                                    dispatch(open(false));
                                    callbackConfirmar();
                                }
                            };
                            axios.post(`${global.gConfig.url_base_exames}/assinatura-laudo`, { exame: idExame }, { headers: getHeaders() })
                                .then((res) => {
                                    alertConfig = {
                                        title: strings.sucesso,
                                        message: strings.laudoAssinado,
                                        type: 'success'
                                    };
                                })
                                .catch(err => {
                                    alertConfig = {
                                        title: strings.erro,
                                        message: strings.erroAssinatura,
                                        type: 'error'
                                    };
                                })
                                .finally(() => {
                                    dispatch(configure(alertConfig));
                                    setAssinando(false);
                                });
                        }
                    }, 1500);
                } else {
                    callbackConfirmar();
                }
            })
            .catch(err => {
                console.log(err);
                const { response } = err;
                let msg = strings.mensagemErroGeral;
                const alertConfig = {
                    title: strings.erro,
                    message: msg,
                    type: 'error',
                    open: true,
                    options: [
                        {
                            title: strings.ok,
                            onClick: () => {
                                dispatch(open(false));
                            }
                        }
                    ],
                    onClose: () => {
                        dispatch(open(false));
                    }
                };

                if (response && (response.status === HttpStatus.BAD_REQUEST || response.status === HttpStatus.INTERNAL_SERVER_ERROR)) {
                    let arrMensagem = [];
                    response.data.errors.forEach(error => {
                        arrMensagem.push(`- ${error.message}`);
                    });
                    msg = arrMensagem.join('\n');
                    alertConfig.titulo = response.data.message;
                    alertConfig.message = msg;
                }
                dispatch(configure(alertConfig));
            })
            .finally(() => {
                setConfirmando(false);
            });
    }

    return (
        <>
            <SttModal
                title={strings.resumoLaudo}
                open={modalAberto}
                outModalClose={callbackCancelar}
                iconClose={callbackCancelar}
                maxWidth="lg"
                fullWidth={true}
                children={
                    <div dangerouslySetInnerHTML={{ __html: html }}></div>
                }
                footer={
                    <div>
                        <SttButton variant="contained" color="primary" disabled={confirmando} onClick={confirmar}>
                            {strings.confirmar}
                        </SttButton>
                        <SttButton variant="outlined" color="primary" onClick={callbackCancelar}>
                            {strings.cancelar}
                        </SttButton>
                    </div>
                }
            />
            <SttLoading
                open={confirmando}
                text={strings.confirmando}
            />
            <SttLoading
                open={assinando}
                text={strings.assinando}
            />
        </>
    );
}

ConfirmarLaudo.propTypes = {
    callbackConfirmar: PropTypes.func.isRequired,
    callbackCancelar: PropTypes.func.isRequired,
};

export default ConfirmarLaudo;